var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    viewBox: "0 0 3325 3300",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3325,
    height: 3300
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3325,
    height: 3300
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "#00ff85",
    strokeWidth: "51.77px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1208.1 1588.9c-75.783 0-137.31 61.527-137.31 137.31v626.48c0 75.783 61.527 137.31 137.31 137.31 75.784-0 137.31-61.527 137.31-137.31v-626.48c0-75.783-61.526-137.31-137.31-137.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2108.1 844.49c-75.783-0-137.31 61.526-137.31 137.31v626.48c0 75.784 61.527 137.31 137.31 137.31 75.784 0 137.31-61.526 137.31-137.31v-626.48c0-75.784-61.526-137.31-137.31-137.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2562.3 1918.6c-75.783-0-137.31 61.526-137.31 137.31v626.48c-0 75.784 61.527 137.31 137.31 137.31s137.31-61.526 137.31-137.31v-626.48c-0-75.784-61.527-137.31-137.31-137.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1208.1 552.71c-75.783-0-137.31 61.526-137.31 137.31v626.48c0 75.783 61.527 137.31 137.31 137.31 75.784-0 137.31-61.527 137.31-137.31v-626.48c0-75.784-61.526-137.31-137.31-137.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.31 1277.8c-75.783 0-137.31 61.527-137.31 137.31v626.48c-0 75.783 61.527 137.31 137.31 137.31s137.31-61.527 137.31-137.31v-626.48c-0-75.783-61.527-137.31-137.31-137.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.31 253.58c-75.783-0-137.31 61.526-137.31 137.31v626.48c-0 75.783 61.527 137.31 137.31 137.31s137.31-61.527 137.31-137.31v-626.48c-0-75.784-61.527-137.31-137.31-137.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1654 1224.6c-75.784 0-137.31 61.527-137.31 137.31v626.48c-0 75.783 61.526 137.31 137.31 137.31 75.783-0 137.31-61.527 137.31-137.31v-626.48c-0-75.783-61.527-137.31-137.31-137.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1654 2280.8c-75.784-0-137.31 61.526-137.31 137.31v626.48c-0 75.784 61.526 137.31 137.31 137.31 75.783 0 137.31-61.526 137.31-137.31v-626.48c-0-75.784-61.527-137.31-137.31-137.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1654 196.35c-75.784 0-137.31 61.527-137.31 137.31v626.48c-0 75.783 61.526 137.31 137.31 137.31 75.783-0 137.31-61.527 137.31-137.31v-626.48c-0-75.783-61.527-137.31-137.31-137.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2563.6 478.41c-75.783-0-137.31 61.526-137.31 137.31v626.48c0 75.784 61.527 137.31 137.31 137.31s137.31-61.526 137.31-137.31v-626.48c0-75.784-61.527-137.31-137.31-137.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2991.6 87.926c-75.783-0-137.31 61.526-137.31 137.31v626.48c0 75.784 61.527 137.31 137.31 137.31s137.31-61.526 137.31-137.31v-626.48c-0-75.784-61.527-137.31-137.31-137.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m745.06-112.5c-75.784-0-137.31 61.527-137.31 137.31v626.48c-0 75.783 61.526 137.31 137.31 137.31 75.783-0 137.31-61.527 137.31-137.31v-626.48c-0-75.783-61.527-137.31-137.31-137.31z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.a2a2e529ee6b3ab8e9e7dac8f664ed33.svg";
export { ForwardRef as ReactComponent };